import { imageBasePath } from 'constants';
import { Avatar, DialogTitle, Grid } from '@material-ui/core';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import styles from '../../../assets/styles/training.module.scss';
import Organization from 'infrastructure/Organization';
import { useSalesRepView } from 'features/salesRepView/SalesRepView.hook';

const FeedbackAssessmentTitle = ({
  handleClose = () => null,
  averageRating,
  userAssessment = {},
  title = `Assessment`,
  showScore = false,
  score_status,
  score = 0,
}) => {
  const { isActive } = useSalesRepView();
  const isRep = Organization?.isRep() || isActive;
  return (
    <>
      <DialogTitle id="add-video-title" className={styles.dialogTitle}>
        <img
          src={imageBasePath + 'close_gray.svg'}
          alt="close icon"
          className="modalCloseIcon"
          onClick={handleClose}
        />
        <Grid container direction="row" alignItems="center" justify="space-between">
          <Grid item>
            <span className={styles.title + ' heading4 flexCentered'}>
              <img src={imageBasePath + 'setup_training.svg'} alt="image_training" />
              <span>{title}</span>
            </span>
          </Grid>
          {isRep && averageRating !== undefined && (
            <Grid item>
              <div className={styles.assessmentCircularProgress}>
                <div className={styles.circularProgressBar}>
                  <CircularProgressbar
                    strokeWidth={12}
                    value={averageRating}
                    maxValue={5}
                    styles={buildStyles({
                      textColor: ' #778DA9',
                      pathColor: '#0494FD',
                      trailColor: '#D8E1E9',
                      textSize: '16px',
                      strokeLinecap: 'butt',
                    })}
                  />
                </div>
                <p className="supportText"> Avg Rating: {averageRating}/5</p>
              </div>
            </Grid>
          )}
        </Grid>
        {!isRep && (
          <div className={styles.infoOuterWrapper}>
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={2}
              className={styles.contentRow}
            >
              <Grid item lg={6} md={8} sm={8} xs={8}>
                <div className={styles.userInfoWrapper + ' textCenter flexCentered'}>
                  <div className={styles.userImgBlk}>
                    {userAssessment && userAssessment?.profile_pic ? (
                      <img
                        className="profilePic"
                        src={userAssessment?.profile_pic}
                        alt="Profile pic"
                      />
                    ) : (
                      <Avatar className={`avatar ${styles.userImg}`}>
                        {' '}
                        {userAssessment?.first_name
                          ? userAssessment?.first_name.substring(0, 1)
                          : userAssessment?.email
                          ? userAssessment?.email.substring(0, 1)
                          : ''}
                      </Avatar>
                    )}
                  </div>
                  <div className={styles.contentBlk}>
                    {userAssessment?.first_name || userAssessment?.last_name ? (
                      <h3 className="heading4">{`${
                        userAssessment?.first_name
                          ? userAssessment?.first_name
                          : userAssessment?.last_name
                      } ${
                        userAssessment?.first_name && userAssessment?.last_name
                          ? userAssessment?.last_name
                          : ''
                      }`}</h3>
                    ) : (
                      ''
                    )}
                    <p className={styles.designation + ' supportTextSemibold'}>
                      <img src={`${imageBasePath}designation_icon.svg`} alt="" />
                      <span>
                        {userAssessment?.designation ? userAssessment?.designation : '--'}{' '}
                      </span>
                    </p>
                    <p className="supportTextSemibold">
                      <img src={`${imageBasePath}email_icon.svg`} alt="" />
                      <span className={styles.email}>{userAssessment?.email}</span>
                    </p>
                    {showScore && (
                      <p className="supportText">
                        Score:{' '}
                        <b
                          className={`${
                            score_status === 1 ? styles.score_success : styles.score_failed
                          }`}
                        >
                          {score}%
                        </b>
                      </p>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        )}
      </DialogTitle>
    </>
  );
};

export default FeedbackAssessmentTitle;
